require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
module.exports = require('../modules/_core').Map;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/es6/map.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/es6/map.js
// module chunks = 168707334958949